module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('v-catalogue', {
    attrs: {
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle
    }
  }), _vm._v(" "), _c('v-blogTags', {
    attrs: {
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ede5164"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/sidebar/sidebar.vue
// module id = 279
// module chunks = 1